import myAxios from '../utils/request.js';
import callback from "../utils/callback.js";

export default {
    // 搜索书籍
    async searchBookList (params={}, cb) {
        let res = await myAxios.getJson('/searchBook', params);
        return res.data;
    },

    // 获取推荐书籍
    async getRecommendBookList (params={}, cb) {
        let res = await myAxios.getJson('/getRecommendBookList', params);
        return res.data;
    },

    // 获取书籍详情
    async getBookInfo (params={}, cb) {
        let res = await myAxios.getJson('/getBookInfo', params);
        return res.data;
    },

    // 获取书籍List
    async getBookList (params={}, cb) {
        let res = await myAxios.getJson('/getBookList', params);
        return res.data;
    },

    // 获取书籍分类
    async getBookSortList (params={}, cb) {
        let res = await myAxios.getJson('/getBookSortList', params);
        return res.data;
    },
};
